module.exports = __webpack_public_path__ + "media/src/components/HomePage/Benefit/get-covered-a9dd306a549859a0cc25288d3af69b6f.png";